import postAPI from './postAPI.js'

export default async function getTaskMessages(taskInstanceId) {
    const data = await postAPI('taskmessages/get', { task_instance_id: taskInstanceId });
    return data;
}
